var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3406_11757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 8.66697C6.95293 9.04972 7.3182 9.36642 7.73766 9.5956C8.15712 9.82477 8.62096 9.96105 9.09773 9.99519C9.57449 10.0293 10.053 9.96055 10.5009 9.79349C10.9487 9.62643 11.3554 9.36502 11.6933 9.02697L13.6933 7.02697C14.3005 6.3983 14.6365 5.55629 14.6289 4.6823C14.6213 3.80831 14.2707 2.97227 13.6527 2.35424C13.0347 1.73621 12.1986 1.38565 11.3246 1.37806C10.4506 1.37046 9.60863 1.70644 8.97996 2.31364L7.83329 3.45364",
    stroke: "#586581",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 7.33381C9.04704 6.95106 8.68177 6.63435 8.26231 6.40518C7.84285 6.17601 7.37901 6.03973 6.90224 6.00559C6.42548 5.97144 5.94695 6.04023 5.49911 6.20729C5.05127 6.37435 4.6446 6.63576 4.30668 6.97381L2.30668 8.97381C1.69948 9.60248 1.3635 10.4445 1.3711 11.3185C1.37869 12.1925 1.72926 13.0285 2.34728 13.6465C2.96531 14.2646 3.80135 14.6151 4.67534 14.6227C5.54933 14.6303 6.39134 14.2943 7.02001 13.6871L8.16001 12.5471",
    stroke: "#586581",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3406_11757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.58d1db229df68965c81482714a5d3ac5.svg";
export { ForwardRef as ReactComponent };